import axios from 'axios'
import jwt_decode from 'jwt-decode'

const auth = {
    namespaced: true,
    state: {
        active: 'wifi',
        loggedIn: {refresh:"",access:""},
        modal: false,
        maxRange: false,
        oneDayLineRange: true
    },
    mutations: {
        SET_LOGGED_IN (state, isLoggedIn){
            state.loggedIn = isLoggedIn
        },
        SET_ACCESS_TOKEN (state, token){
            state.loggedIn.access = token.access
        },
        SET_ACTIVE(state, activeModule){
            state.active = activeModule
        },
        SET_MODAL(state, condition){
            state.modal = condition
        },
        SET_MAX_RANGE(state, max){
            state.maxRange = max
        },
        SET_ONE_DAY_LINE_RANGE(state, one_day){
            state.oneDayLineRange = one_day
        },
    },
    actions: {
        userLogin({ commit }, authData){
            return new Promise((resolve, reject) => {
                axios
                    .post(process.env.VUE_APP_CORE_HOST+"/api/token/", authData)
                    .then(response => {
                        commit('SET_LOGGED_IN', response.data)
                        resolve(JSON.stringify(response.data))
                    })
                    .catch(err => {
                        console.log(err)
                        reject(err)
                    })
            })
        },
        userLogout({ commit }) {
            commit('SET_LOGGED_IN', {refresh:"",access:""})
        },
        inspectToken({dispatch, state}){
            var access = jwt_decode(state.loggedIn.access);
            var refresh = jwt_decode(state.loggedIn.refresh);
            if (access.exp - (Date.now()/1000) <= 0 && refresh.exp - (Date.now()/1000) > 0) {
                dispatch('refreshToken');
            } else if (access.exp - (Date.now()/1000) <= 0 && refresh.exp - (Date.now()/1000) <= 0) {
                dispatch('userLogout');
            }
        },
        refreshToken({commit, state}) {
            axios
                .post(process.env.VUE_APP_CORE_HOST+"/api/token/refresh/", {'refresh': state.loggedIn.refresh})
                .then(response => {
                    commit('SET_ACCESS_TOKEN', response.data)
                })
                .catch(err => {
                    console.log(err)
                })
        },
        setActive({ commit }, activeModule){
            commit('SET_ACTIVE', activeModule)
        },
        changeModal({commit}, condition){
            commit('SET_MODAL', condition)
        },
        changeMaxRange({commit}, max){
            commit('SET_MAX_RANGE', max)
        },
        changeOneDayLineRange({commit}, one_day){
            commit('SET_ONE_DAY_LINE_RANGE', one_day)
        }
    },
    getters: {
        isLoggedIn(state){
            return state.loggedIn
        },
        getActive(state){
            return state.active
        },
        getModal(state){
            return state.modal
        },
        getMaxRange(state){
            return state.maxRange
        },
        getOneDayLineRange(state){
            return state.oneDayLineRange
        },
        getAppName(){
            return process.env.VUE_APP_NAME
        },
        getActiveTitle(state){
            if (state.active == "resume") {
                return "Resumen"
            } else if (state.active == "wifi") {
                return "Conexiones Portal Cautivo"
            } else if (state.active == "content") {
                return "Contenidos"
            } else if (state.active == "infra") {
                return "Presencia"
            } else if (state.active == "clusters") {
                return "Clusters"
            } else if (state.active == "downloads") {
                return "Descargas"
            }
            
        }
    }
}

export default {
    auth
}
